import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// Bump to bust the CloudFront cache when widget-params-map.json changes.
const WIDGET_PARAMS_MAP_VERSION = '2.2';
const WIDGET_PARAMS_MAP_URL = `https://d27vx6ekipa712.cloudfront.net/config/widget-params-map.json?v=${WIDGET_PARAMS_MAP_VERSION}`;

// Static config file (not a BFF endpoint) — plain axios, same as getIPLocation.
function isValidWidgetParamsMap(data) {
    return !!data && typeof data.publishers === 'object' && data.publishers !== null && !Array.isArray(data.publishers);
}

const REQUEST_TIMEOUT_MS = 8000;

async function getWidgetParamsMap() {
    try {
        const res = await axios.get(WIDGET_PARAMS_MAP_URL, { timeout: REQUEST_TIMEOUT_MS });
        this.widgetParamsMap = isValidWidgetParamsMap(res?.data) ? res.data : { publishers: {} };
    } catch (err) {
        // caller falls back to each publisher's own widgetParamsString
        console.error('getWidgetParamsMap() failed -> ', err);
        this.widgetParamsMap = { publishers: {} };
    }
    this.observed.widgetParamsMap = uuidv4();
}

export default getWidgetParamsMap;
